import { useState } from 'react';
import PropTypes from 'prop-types';
import { ModalServiceData } from './ModalServiceData';
import { ModalEditService } from '../../views/Calendar/components/ModalEditService';
import CancelServiceModal from '../../views/ServicesHistory/components/CancelServicesModal';

export function useModalServiceEvent({ onSaveData }) {
  const [selectedServiceData, setSelectedServiceData] = useState({
    showDetailsModal: false,
    showEditModal: false,
    showCancelModal: false,
    serviceId: null,
  });

  const handleEditService = (id) => () => {
    setSelectedServiceData({
      showEditModal: true,
      serviceId: id,
    });
  };

  const onHanldeCloseModalEdit = () => {
    if (onSaveData) onSaveData();
    setSelectedServiceData({
      showEditModal: false,
    });
  };

  const handleCancelService = (id) => () => {
    setSelectedServiceData({
      showCancelModal: true,
      serviceId: id,
    });
  };

  const closeModalCancel = (reloadEvents) => {
    if (reloadEvents) {
      if (onSaveData) onSaveData();
    }
    setSelectedServiceData({
      showCancelModal: false,
    });
  };

  const handleOpenModal = (id) => {
    setSelectedServiceData({ showDetailsModal: true, serviceId: id });
  };

  const handleCloseModal = (refresh) => {
    if (refresh && onSaveData) onSaveData();

    setSelectedServiceData((current) => ({ ...current, showDetailsModal: false }));
  };

  return {
    selectedServiceData,
    handleEditService,
    onHanldeCloseModalEdit,
    handleCancelService,
    closeModalCancel,
    handleOpenModal,
    handleCloseModal,
  };
}

export function ModalServiceEvent({
  selectedServiceData,
  handleEditService,
  onHanldeCloseModalEdit,
  handleCancelService,
  closeModalCancel,
  handleCloseModal,
}) {
  return (
    <>
      {selectedServiceData?.showEditModal ? (
        <ModalEditService
          show={selectedServiceData?.showEditModal}
          serviceId={selectedServiceData.serviceId}
          handleClose={onHanldeCloseModalEdit}
        />
      ) : null}

      {selectedServiceData?.showCancelModal ? (
        <CancelServiceModal
          handleClose={closeModalCancel}
          show={selectedServiceData?.showCancelModal}
          serviceId={selectedServiceData.serviceId}
        />
      ) : null}
      {selectedServiceData?.showDetailsModal ? (
        <ModalServiceData
          show={selectedServiceData.showDetailsModal}
          handleCancelService={handleCancelService(selectedServiceData.serviceId)}
          handleEditService={handleEditService(selectedServiceData.serviceId)}
          serviceId={selectedServiceData.serviceId}
          handleClose={handleCloseModal}
        />
      ) : null}
    </>
  );
}

ModalServiceEvent.propTypes = {
  selectedServiceData: PropTypes.shape({
    showDetailsModal: PropTypes.bool,
    showEditModal: PropTypes.bool,
    showCancelModal: PropTypes.bool,
    serviceId: PropTypes.string,
  }),
  handleEditService: PropTypes.func,
  onHanldeCloseModalEdit: PropTypes.func,
  handleCancelService: PropTypes.func,
  closeModalCancel: PropTypes.func,
  handleCloseModal: PropTypes.func,
}